<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">

  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Termeni si conditii</h1>

  <div class="row">
    <div class="col-md-10">

      <h2 class="h1 pb-2">I. Aspecte generale privind serviciile si continutul raportului juridic</h2>
      <p>Anterior utilizarii prezentului site web si a contractarii serviciilor pe care
        <strong>IT INNOVATION CORP S.R.L.</strong> le pune la dispozitie prin intermediul acestui site, va rugam
        cititi
        cu atentie toti termenii si toate conditiile de utilizare prevazute in prezentul document, asumandu-va
        faptul
        ca acceptarea acestora presupune intelegerea tuturor conditiilor si a mecanismelor de achizitionare a
        serviciilor
        furnizate de catre
        <strong>IT INNOVATION CORP S.R.L.</strong>. In acest sens, insusirea in orice faza a utilizarii site-ului
        a
        prezentelor conditii presupune acceptarea acestora in integralitatea lor, fara obiectiuni, in mod
        irevocabil
        si presupune un contract incheiat intre parti.
      </p>
      <p>Pentru a inlatura orice dubiu, acceptarea termenelor si conditiilor presupune intelegerea in
        integralitate a
        modalitatii de prestare a serviciilor de catre
        <strong>IT INNOVATION CORP S.R.L.</strong>, asa cum sunt descrise in prezentul document si cum rezulta din
        orice material publicat pe portalul web (
        <a href="https://www.giftshare.ro">www.giftshare.ro</a> ), consumatorul fiind singurul in masura sa decida
        cu privire la utilizarea sau neutilizarea acestuia.
      </p>
      <p>Utilizarea prezentului portal web presupune: </p>
      <ol>
        <li>acceptarea termenilor si conditiilor vanzarii, respectiv cumpararii serviciilor, insemnand continutul
          concret
          al raportului juridic; </li>
        <li>prelucrarea de date cu caracter personal potrivit
          <i>Regulamentului (UE) 2016/679 al Parlamentului European si al Consiliului din 27 aprilie 2016 privind
            protectia
            persoanelor fizice in ceea ce priveste prelucrarea datelor cu caracter personal si privind libera
            circulatie
            a acestor date si de abrogare a Directivei 95/46/CE (Regulamentul general privind protectia datelor -
            GDPR);</i>
        </li>
        <li>alti termeni si conditii care rezulta din prezentul document sau din alte acte incheiate intre parti.
        </li>
      </ol>
      <p>In considerarea unei cat mai bune si uniforme interpretari a Termenilor si Conditiilor de utilizare ale
        site-ului
        web, precum si a drepturilor si obligatiilor care decurg din acceptarea acestora, urmatorii termeni vor fi
        interpretati dupa cum urmeaza:</p>
      <ol>
        <li>
          <strong>consumator persoana fizica</strong>: persoana fizica parte a raportului juridic rezultat prin
          utilizarea
          portalului web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a> care beneficiaza de serviciile portalului
          potrivit
          metodologiei expuse in Termeni si Conditii;
        </li>
        <li>
          <strong>beneficiar</strong>: persoana fizica parte a raportului juridic civil rezultat prin utilizarea
          portalului
          web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a> care initiaza o campanie in scopul colectarii de
          la consumatorii persoane fizice a unor sume de bani, in scopul achizitionarii pentru sine de bunuri si
          servicii,
          ori in scopul efectuarii de donatii, in conditiile prezentelor reglementari;
        </li>
        <li>
          <strong>vanzatorul</strong>: persoana juridica inmatriculata si autorizata potrivit legii in vigoare, cu
          care
          <strong>IT INNOVATION CORP S.R.L.</strong> se afla in raporturi contractuale, si care furnizeaza bunuri
          sau
          presteaza servicii la cererea Beneficiarului, in schimbul sumelor colectate;
        </li>
        <li>
          <strong>intermediarul</strong>: societatea
          <strong>IT INNOVATION CORP S.R.L.</strong> in calitate de proprietar al platformei web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a>;
        </li>
        <li>
          <strong>solicitantul persoana juridica</strong>: persoana juridica sau fara personalitate juridica dar
          care
          intra in sfera profesionistilor potrivit prevederilor Noului Cod Civil, parte a raportului juridic
          rezultat
          prin utilizarea portalului web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a> care beneficiaza de serviciile portalului
          potrivit
          metodologiei expuse in Termeni si Conditii;
        </li>
        <li>
          <strong>contract / contractare / perioada de contractare</strong>: raport juridic initiat si/sau derulat
          de catre
          consumator si/sau solicitant persoana juridica si/sau intermediat si sau/vanzator, potrivit metodologiei
          de functionare a portalului web si in acord cu prezentele termene si conditii; perioada de contractare
          dintre
          consumator / solicitant persoana juridica/beneficiar pe de o parte si intermediar pe de alta parte, se
          desfasoara
          astfel:
          <ul>
            <li>pentru consumator/solicitantul persoana juridica incepand cu data inscrierii sau acceptarii unei
              campanii
              cu scopul participarii si pana la finalizarea evenimentului cu consecinta implinirii termenului de
              colectare;</li>
            <li>pentru beneficiar, incepand cu data generarii campaniei cu consecinta publicarii unui eveniment
              personal
              si pana la efectuarea platilor catre vanzator/vanzatori; ulterior acestor perioade, intermediarul nu
              va mai depune nicio diligenta. </li>
          </ul>
        </li>
        <li>
          <strong>campanie</strong>: eveniment initiat de catre beneficiar si gazduit prin intermediul platformei
          <a href="https://www.giftshare.ro">www.giftshare.ro</a>, in scopul colectarii de fonduri de la
          consumatori
          si/sau solicitantii persoane juridice, fonduri ce urmeaza a fi utilizate in achizitionarea de bunuri sau
          servicii de la vanzatori ori in scopuri caritabile prin efectuarea de donatii;
        </li>
        <li>
          <strong>voucher/card cadou</strong>: reprezinta reducerea oferita beneficiarului ca urmare a sumelor
          colectate
          de la consumatorii persoane fizice si solicitantii persoane juridice, evidentiata printr-un document
          justificativ
          electronic sau/si in forma fizica, care reprezinta un echivalent valoric in lei si prin intermediul
          caruia
          beneficiarul achizitioneaza pentru sine bunuri si servicii de la vanzatorii parteneri ai
          intermediarului;
        </li>
        <li>
          <strong>membri</strong>: membri persoane fizice inregistrati ai platformei
          <a href="https://www.giftshare.ro">www.giftshare.ro</a>, denumiti in mod colectiv, indiferent ca sunt
          consumatori.
        </li>
      </ol>
      <p>Societatea
        <strong>IT INNOVATION CORP S.R.L.</strong>, societate de nationalitate romana, titulara dreptului de
        proprietate
        asupra site-ului web
        <a href="https://www.giftshare.ro">www.giftshare.ro</a> precum si proprietar asupra tuturor drepturilor de
        proprietate intelectuala si de autor asupra continutului acestuia, in conditiile legii, isi rezerva
        dreptul
        de a schimba si actualiza in orice moment continutul site-ului web, a politicii de confidentialitate, a
        termenelor
        si conditiilor de utilizare, precum si a mecanismelor de functionare, fara nicio notificare prealabila,
        utilizatorii
        (consumatorii/solicitantii persoane juridice/beneficiarii) avand obligatia de minima digilienta in a
        consulta
        periodic termenele si conditiile de utilizare a portalului web. Prin acceptarea termenilor si conditiilor
        de
        utilizare, consumatorul persoana fizica, beneficiarul si solicitantul persoana juridica isi asuma o
        obligatie
        de diligenta in sensul verificarii periodice si ori de cate ori contracteaza serviciile puse la dispozitie
        de catre intermediar, intelegand si asumandu-si faptul ca intermediarul nu este tinut obligat sa informeze
        tertii cu privire la modificarea acestora. Termeni si conditiile pot suferi modificari succesive in scopul
        imbunatatirii permanente a serviciilor furnizate prin intermediul site-ului web, datorita modificarii
        oricaror
        elemente care tin de functiunea site-ului web sau a metodologiei de utilizare a acestuia, precum si in
        scopul
        adaptarii politicilor site-ului web la legislatia in vigoare. Serviciile contractate in perioada de
        valabilitate
        a unei versiuni a termenilor si conditiilor raman valabile pana la epuizarea serviciilor contractate, mai
        precis
        pana la incheierea campaniei. Astfel, indemnam toate persoanele interesate de prezentele termene si
        conditii
        sa le verifice periodic, sa le studieze cu meticulozitate si sa decida in consecinta daca urmeaza sa
        utilizeze
        sau nu serviciile puse la dispozitie de catre
        <strong>IT INNOVATION CORP S.R.L.</strong> prin intermediul site-ului web
        <a href="https://www.giftshare.ro">www.giftshare.ro</a>, Intermediarul nu va fi tinut raspunzator pentru
        nicio
        reclamantie/pretentie ulterioara acceptarii termenelor si conditiilor.
      </p>
      <p>
        <strong>IT INNOVATION CORP S.R.L.</strong> isi rezerva dreptul de a limita accesul tertilor la serviciile
        sale
        si de a sterge contul oricarui consumator persoana fizica sau beneficiar, in cazul justificat in care
        considera
        ca accesul pe site-ul web si existenta contului ar putea prejudicia in vreun fel intermediarul sau
        vanzatorul.
      </p>
      <p>Conturile de utilizator multiple (consumator persoana fizica, beneficiar sau solicitant persoana
        juridica), apartinand
        aceleiasi persoane, fizice sau juridice, ca regula nu sunt agreate de catre Intermediar, acesta
        rezervandu-si
        dreptul de a verifica prin mijloace specifice existenta acestora. Prin exceptie, ocazional, o persoana
        fizica
        sau juridica poate indeplini mai multe din calitatile mai sus enumerate concomitent insa doar in campanii
        diferite.
        In cazul in care intermediarul va constata faptul ca asemenea conturi sunt utilizate in vederea fraudarii
        intereselor
        noastre, vom proceda de indata la blocarea conturilor mai sus mentionate, si ne rezervam dreptul de a
        refuza
        orice plati ce ar fi datorate in urma unor operatiuni dolosive. Totodata, ne rezervam dreptul de a initia
        orice
        proceduri judiciare prevazute de lege in vederea tragerii la raspundere a persoanelor aflate in culpa,
        precum
        si la recuperarea oricarui prejudiciu suferit in urma unor asemenea operatiuni, inclusiv cheltuielile cu
        diverse
        servicii profesionale: avocati, experti in tehnologia informatiei, experti contabili s.a.m.d.. Pasivitatea
        Intermediarului in adoptarea unei pozitii nu presupune si nu va fi interpretat sub nicio forma ca fiind o
        renuntare
        la dreptul pretins. </p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">II. Filozofia care sta la baza serviciilor prestate de catre
        <strong>IT INNOVATION CORP S.R.L.</strong> prin intermediul site-ului web
        <a href="https://www.giftshare.ro">www.giftshare.ro</a>
      </h2>
      <ol>
        <li>Site-ul web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a> functioneaza ca intermediar intre Beneficiarul
          persoana
          fizica sau solicitantul persoana juridica, pe de o parte, si vanzatorul in calitate de partener al
          intermediarului
          pe de alta parte. Astfel, continutul raportului juridic de vanzare, respectiv cumparare, intervine intre
          beneficiarul persoana fizica onclusiv in calitatea lui de salariat/ colaborator al solicitantului persoana
          juridica si vanzatorul, partener al intermediarului, in mod direct, nascand astfel toate obligatiile
          legale
          privitoare la transferul dreptului de proprietate sau protectia consumatorului. In acest context,
          beneficiarul
          persoana fizica sau solicitantul persoana juridica achizitioneaza in mod formal de la intermediar un
          voucher/
          card valoric transmisibil unei terte persoane, fizice sau juridice, denumite beneficiar si care in confera
          dreptul de a achizitiona faptic de la oricare din vanzatorii, parteneri ai intermediarului, bunuri si
          servicii
          in conditii preferentiale sau organizate. Rolul intermediarului este acela de a pune la dispozitia tuturor
          partilor interesate sau implicate o platforma, materializata sub forma unui site web, care sa faciliteze
          acest mecanism de vanzare – cumparare si care sa permita generarea de campanii, reprezentand evenimente
          (zile
          de nastere, evenimente festive, nunti etc.), create in mod exclusiv de catre beneficiari. Astfel,
          Beneficiarul
          genereaza un eveniment care poate viza un moment personal special in cadrul caruia pot participa atat
          consumatorii
          persoane fizice cat si solicitantii persoane juridice in scopul colectarii si acumularii de fonduri
          banesti
          pe numele beneficiarului, de catre intermediar, fonduri cu care beneficiarul poate opta pentru
          voucherele/cardurile
          puse la dispozitie de catre intermediar prin intermediul site-ului web. In temeiul acestor
          vouchere/carduri
          achizitionate, beneficiarul achizitioneaza bunuri si servicii de la vanzatorii parteneri ai
          intermediarului.
          Din perspectiva raportului juridic, intermediarul furnizeaza consumatorului persoana fizica si
          solicitantului
          persoana juridica serviciile de colectare a unor fonduri banesti, intr-un cont colector, la dispozitia
          beneficiarului
          in calitatea sa de initiator al campaniei/evenimentului, beneficiind de un mandat in acest sens prin
          acceptarea
          termenelor si conditiilor. De asemenea, in virtutea mandatului in temeiul caruia intermediarul asigura
          colectarea
          si gestionarea fondurilor, acesta va efectua plata directa catre vanzatori, parteneri ai intermediarului,
          in scopul achitarii formale a sumelor de bani reprezentand echivalentul valoric al voucherelor/
          cardurilor.
          Astfel, intermediarul actioneaza ca intermediar si mandatar, formalizand niste tranzactii in numele si pe
          seama Consumatorului persoana fizica, solicitantului persoana juridica, beneficiarului si a vanzatorului.
          Cu exceptia serviciilor prestate de catre intermediar, constand in comisioanele percepute de catre acesta
          potrivit informatiilor de pe site, intermediarul nu este tinut raspunzator pentru nicio achizitie
          efectuata
          de catre beneficiar sau pentru niciun alt eveniment neplacut care excede serviciilor de intermediere.
          Pentru
          a inlatura orice dubiu, site-ul web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a> faciliteaza oferirea de cadouri si daruri manuale
          de catre consumatorii persoane fizice si solicitantii persoane juridice catre beneficiari cu utilizarea
          site-ului
          web, in baza unor vouchere/carduri pe care din punct de vedere formal, intermediarul le contracteaza in
          conditii
          speciale de la vanzatori, parteneri ai intermediarului, oferind astfel un instrument on-line, practic si
          facil de achizitionare de cadouri cu diverse ocazii. Decizia suspendarii sau inchiderii anticipate a unei
          campanii/eveniment este, de regula, a beneficiarului caz in care nu se vor percepe comisioane iar sumele
          vor fi restituie. In mod exceptional, intermediarul poate interveni si poate bloca accesul/suspenda sau
          inchide
          o campanie/eveniment daca exista suspiciuni rezonabile ca acestea sunt simulate, au continut imoral,
          vizeaza
          savarsirea de fapte antisociale, lezeaza interesele unor indivizi sau colectivitati, promoveaza ideologii
          politice sau instiga la ura, violenta, rasism, sau fac obiectul unor infractiuni, situatie in care
          Intermediarul
          va sesiza organele de cercetare penala, potrivit legii.
        </li>
        <li>Prestatia asigurata de catre intermediar in scopul comisioanelor percepute nu va fi confundata cu
          achizitionarea
          de catre beneficiar a produselor si serviciilor in baza voucherelor/ cardurilor puse la dispozitie de
          catre
          intermediar. Astfel, in relatie cu consumatorul persoana fizica si solicitantul persoana juridica, precum
          si in relatie cu beneficiarul, raspunzatorul pentru viciile bunurilor sau serviciilor achizitionate in
          baza
          voucherului/ cardului este, in mod exclusiv, vanzatorul. Cu toate acestea, consumatorul persoana fizica si
          solicitantul persoana juridica pot formula pretentii asupra sumelor avansate in contul colector, in termen
          de cel mult 15 zile calculate de la data platii, dar nu mai mult de data inchiderii
          campaniei/evenimentului,
          putand ordona restituirea acestora. Restituirea sumelor la cererea persoanelor mai sus enuntate se vor
          reflecta
          atat in contul colector cat si in instrumentele de monitorizare regasite pe site-ul web. Ulterior
          inchiderii
          campaniei/ evenimentului sumele colectate si care devin exigibile in folosul beneficiarului in vederea
          achizitionarii
          voucherelor/ cardurilor nu vor fi returnate de catre intermediar ci pot fi pretinse doar de la beneficiar.
          Pentru orice sesizari in privinta returnarii sumelor creditate de catre consumatorii persoane fizice sau
          solicitantii persoane juridice, in conditiile prezentelor reglementari, persoana in cauza va transmite un
          e-mail pe adresa contact&#64;giftshare.ro. Sesizarile ulterioare perioadei de 15 zile nu vor fi luate in
          considerare
          si, prin urmare, nu vor fi procesate.
        </li>
        <li>Site-ul web asigura si o componenta sociala, filantropica, in care intermediarul permite organizatiilor
          non-guvernamentale
          initierea de campanii/ evenimente in scopul colectarii de fonduri/ donatii pentru cazurile sociale expuse
          punctual. Termenii si conditiile sunt aplicabile inclusiv acestor campanii/ evenimente, sub toate
          aspectele
          specifice, cu urmatoarele mentiuni:
          <ul>
            <li>intermediarul nu percepe niciun comision pentru donatiile efectuate in beneficiul acestor cauze, cu
              exceptia
              costurilor de procesare a platii; </li>
            <li>intermediarul nu este raspunzator pentru veridicitatea evenimentelor/campaniilor initiate de catre
              organizatiile
              in cauza, despre existenta sau inexistenta cauzelor sociale, acesta doar asigurand un spatiu pentru
              afisare
              si instrumentele specifice de promovare; </li>
            <li>orice situatii neplacute sau prejudiciabile cauzate de campaniile/evenimentele initiate de catre
              organizatiile
              non-guvernamentale vor exclude raspunderea intermediarului, atat donatorii cat si organizatiile in
              cauza
              declarand ca toate informatiile furnizate in exercitarea scopului lor prin site-ul web sunt adevarate,
              morale, sub sanctiunea legii penale;</li>
            <li>intermediarul are dreptul nu si obligatia de a impune organizatiilor non-guvernamentale o destinatie
              precisa
              a fondurilor, in sensul in care acestea sa ajunga in mod exclusiv beneficiarilor si nu in alte
              cheltuieli,
              directe sau indirecta, in functie de specificul activitatii organizatiei; </li>
            <li>platile in toate aceste cauze se vor efectua in mod direct in conturile organizatiilor
              non-guvernamentale
              si nu genereaza nicio alta obligatie in sarcina intermediarului precum dar fara sa ne limitam la:
              returul
              sumelor, emiterea de vouchere, oferirea de reduceri s.a.m.d.</li>
          </ul>
        </li>
      </ol>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">III. Informatii despre produse si servicii. Politica de returnare a
        produselor
        achizitionate in temeiul voucherelor/cardurilor.
      </h2>
      <p>Produsele si serviciile pe care Beneficiarul le comanda vor fi furnizate/livrate/prestate/oferite doar de
        catre
        vanzatorul, partener al intermediarului si nu de catre intermediar. Intermediarul nu datoreaza tertilor
        prestarea
        serviciilor sau livrarea produselor, astfel incat orice factura pentru produsul sau serviciul comandat va fi
        emisa doar de catre vanzator, partener al intermediarului si nu de catre intermediar. In mod identic
        certificatele
        de garantie pentru produsele/serviciile comandate vor fi eliberate numai de catre vanzator, in calitate de
        partener al intermediarului, acesta fiind singurul raspunzator pentru calitatea produselor, livrare, pret,
        politica de returnare s.a.m.d. Produsele care nu sunt conforme specificatiilor tehnice sau serviciile care
        nu corespund specificatiilor enumerate, afisate sau furnizate de catre vanzator, in calitate de partener al
        intermediarului, nu angajeaza sub nicio forma raspunderea intermediarului. Toate aspectele ce tin de
        returnarea
        produselor sau anularea serviciilor care fac obiectul cumpararii in baza voucherelor/cardurilor se vor trata
        in mod direct de catre beneficiar si vanzator.
      </p>
      <p>Consumatorilor persoane fizice, solicitantilor persoane juridice si beneficiarilor li se recomanda
        studierea
        temeinica a modului de functionare a serviciilor intermediarului, intelegand si asumandu-si ca intermediarul
        nu poate fi tras la raspundere pentru eventualele consecinte rezultate din retragerea sau renuntarea la
        servicii
        in alte conditii decat cele reglementate prin prezentul document.
      </p>
      <p>
        Prin acceptarea termenilor si conditiilor, acestea produc efecte fata de toate partile implicate
        (consumtorii persoane fizice,
        solicitantii persoane juridice si beneficiarii) si angajeaza raspunderea acestora pe toata perioada de
        contractare.
        Intermediarul nu este raspunzator pentru informatiile furnizate de catre vanzatori, de preturile si
        promotiile
        practicate de catre acestia, de modalitatea de livrare sau asigurare a serviciilor, pentru calitatea
        serviciilor
        si produselor. Prin prezenta in mod irevocabil renuntati la toate pretentiile ce decurg din utilizarea
        voucherelor/cardurilor
        si exonerati intermediarul si angajatii/colaboratorii sai de la plata oricarei datorii care decurge din sau
        in legatura cu orice act sau omisiune a unui vanzator in legatura cu utilizarea unui voucher/card, a
        produselor
        şi/sau serviciilor oferite pe baza acestuia.
      </p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">IV. Apartenenta drepturilor de autor</h2>
      <p>
        <strong>IT INNOVATION CORP S.R.L.</strong> este autorul si proprietarul exclusiv al site-ului web si
        beneficiaza
        de toate drepturile legale recunoscute autorilor, conform legislatiei romane si internationale. In lipsa
        altor
        precizari, toate materialele, incluzand imagini, ilustratii, design-uri, icoane, fotografii, clipuri
        audio/video,
        etc. constituie proprietatea exclusiva a intermediarului, cu exceptia celor care, potrivit metodoligiei de
        functionare a portalului, apartin vanzatorilor parteneri ai inermediarului sau utilizatorilor. Pentru a
        inlatura
        orice dubiu, materialele, incluzand imagini, ilustratii, design-uri, icoane, fotografii, clipuri
        audio/video,
        etc. incarcate sau puse la dispozitie de catre Intermediar si care, prin exceptie, nu apartin tertilor
        colaboratori
        sau utilizatori, sunt in proprietatea exclusiva a intermediarului. Intermediarul isi rezerva dreptul de a se
        adresa instantelor de judecata precum si oricaror institutii publice abilitate pentru protejarea intereselor
        si drepturilor patrimoniale si nepatrimoniale ale acestuia. Denumirea si logoul GiftShare sunt marca
        inregistrata
        a
        <strong>IT INNOVATION CORP S.R.L.</strong>
      </p>
      <p>Intermediarul nu face nici o declaratie cu privire la continutul nici unuia dintre site-urile web pe care
        le
        accesati prin intermediul
        <a href="https://www.giftshare.ro">www.giftshare.ro</a>. La accesarea unui site care nu apartine
        intermediarului,
        va rugam sa aveti in vedere faptul ca site-ul web functioneaza independent de intermediar iar acesta nu
        exercita
        nici un control asupra continutului site-ului in cauza. Stabilirea sau facilitarea unei legaturi (link)
        catre
        un site web independent de site-ul web al intermediarului nu presupune ca intermediarul isi insuseste si
        accepta
        responsabilitatea pentru continutul sau utilizarea unui asemenea site web.
      </p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">V. Diverse</h2>
      <h4>Varsta minima a Beneficiarilor</h4>
      <p>Varsta minima pentru utilizarea portalului
        <a href="https://www.giftshare.ro">www.giftshare.ro</a> este 16 ani. Conditia de varsta trebuie indeplinita
        la data inregistrarii beneficiarului pe portal. Prin acceptarea prezentelor termene si conditii,
        beneficiarul
        declara pe proprie raspundere:
      </p>
      <ol>
        <li>ca indeplineste conditia minima de varsta si, in consecinta, la data inregistrarii are varsta de 16 ani
          impliniti;</li>
        <li>datele minime necesare pentru inregistrare sunt reale.</li>
      </ol>

      <h4>Limitarea raspunderii</h4>
      <p>In masura in care un membru al plaformei formuleaza solicitari care au ca obiect stergerea si/sau
        restituirea
        unor informatii sau documente, dupa caz, precum si limitarea utilizarii anumitor date cu caracter personal
        sau special, aceste situatii pot afecta calitatea serviciilor prestate de catre operator, pot ingreuna
        exercitarea
        obiectului contractului sau pot cauza prejudicii membrilor in cauza ca urmare a neexercitarii de catre
        Operator
        a unor demersuri potrivit metodologiei de functionare a portalului web. In aceste conditii, membrii in cauza
        isi asuma in integralitate consecintele unor astfel de decizii materializate prin solicitari adresate
        Operatorului
        sau prin limitarea ori neacordarea consimtamantului procesarii datelor cu caracter personal/special. </p>
      <p>Consumatorul si/sau Beneficiarul inteleg pe deplin faptul ca activitatea Operatorului genereaza premisele
        prelucrarii
        si/sau stocarii de date cu caracter personal sau special, in conditiile prevazute de Regulament si
        prezentele
        Termene si Conditii, iar lipsa unui consimtamant in acest sens poate cauza imposibilitatea prestarii acestor
        servicii sau diminuarea ori limitarea calitatii/cantitatii acestora. Scopul prelucrarii datelor cu caracter
        personal nu poate fi atins in mod rezonabil prin alte mijloace, decat prin colectare, prelucrare si stocare,
        potrivit prezentelor termene si conditii. </p>
      <p>Acceptarea acestor termene si conditii reprezinta acordul expres si liber consimtit al persoanei vizate si
        confera
        Operatorului dreptul de a procesa si stoca date cu caracter personal sau special, in scopul si conditiile
        declarate
        mai sus. Totodata, insusirea termenilor si conditiilor confirma faptul ca mebrii in cauza au citit si
        inteles
        prevederile acestora, a formulat eventuale intrebari pentru care a primit raspunsuri satisfacatoare intr-un
        limbaj accesibil si clar, potrivit principiului transparentei.</p>
      <p>Membrii platformei sunt raspunzatori pentru asigurarea confidentialitatii datelor privitoare la contul
        propriu
        de acces, cum ar fi numele de utilizator si parola, si sunt responsabili pentru activitatile/actiunile
        desfasurate
        pe platforma web
        <a href="https://www.giftshare.ro">www.giftshare.ro</a>. In cazul in care exista indicii ca, din diverse
        motive
        imputabile sau neimputabile membrului in cauza, confidentialitatea acestor date de acces a fost compromisa,
        acesta va notifica imediat intermediarul pentru a bloca accesul la cont si a va genera cu celeritate un nou
        set de date. Fiecare utilizator (consumator persoana fizica, solicitant persoana juridica, beneficiar) este
        responsabil pentru utilizarea datelor cu caracter personal. Intermediarul nu solicita pentru identificare
        codul
        numeric personal, motiv pentru care comunicarea acestuia din initiativa tertilor nu poate fi imputata
        intermediarului.
        In vederea emiterii documentelor financiar-contabile, intermediarul solicita date precum: datele minime
        prevazute
        de lege. Efectuarea de operatiuni neautorizate asupra acestui site si tentativa de efectuare a acestora,
        incluzand
        fara a se limita la: utilizarea abuziva, utilizarea frauduloasa, accesul neautorizat, modificarea, copierea
        de informatii in vederea comercializarii lor, blocarea accesului, vor face obiectul unei sesizari cu
        consecinta
        aplicarii unor sanctiuni. Societatea
        <strong>IT INNOVATION CORP S.R.L.</strong> respecta si incearca sa protejeze dreptul la intimitate si viata
        privata a utilizatorilor sai, sub rezerva specificului portalului care are ca scop promovarea si/sau
        participarea
        in cadrul unor evenimente personale listate.
      </p>
      <p>Pentru orice informatii suplimentare, va rugam sa ne contactati.
      </p>
      <p>
        <strong>IT INNOVATION CORP S.R.L.</strong>
      </p>
      <p>
        Mun. Bucuresti, Bld. Tineretului nr. 49, bl. 58, sc. 2, sector 4
      </p>
      <p>CUI 37773927 / J40/9405/2017 </p>
      <p>Tel: 0722969596</p>
      <p>E-mail: contact&#64;giftshare.ro</p>
    </div>
  </div>

</section>
